import React from 'react';
import Icon from '@pushpay/icon';

const ProfileSwitcherIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.787 11.417a.207.207 0 00.094-.196.21.21 0 00-.132-.174c-.363-.14-.75-.283-1.167-.436l-.523-.192a.499.499 0 01-.115-.259c-.077-.36-.06-.732.048-1.083a4.68 4.68 0 001.222-3.595C12.214 3.463 10.898 2 9.084 2c-1.815 0-3.13 1.463-3.13 3.478A4.67 4.67 0 007.166 9.06c.12.354.14.733.06 1.097a.507.507 0 01-.112.257l-.526.194c-2.039.75-3.512 1.291-3.962 2.188A7.656 7.656 0 002 15.75c0 .23.187.417.417.417H9.75c.107 0 .197-.081.207-.188a6.198 6.198 0 012.83-4.562zm7.523 7.416a.833.833 0 00-1.17.131l-.002.001a3.646 3.646 0 11-.412-4.985.208.208 0 01.008.302l-1.159 1.155a.416.416 0 00.294.712h3.714c.23 0 .417-.187.417-.417v-3.714a.417.417 0 00-.712-.295l-1.083 1.084a.208.208 0 01-.29.004 5.311 5.311 0 10.523 7.192.833.833 0 00-.128-1.17z",
    fill: "currentColor"
  }));
};

export default ProfileSwitcherIcon;